// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   HIERARCHY SKELETON - Loading Placeholder
   ============================================ */

.hierarchy-skeleton {
  padding: var(--space-3) var(--space-2);
}

/* ============================================
   TREE STRUCTURE - Indentation Levels
   ============================================ */

.skeleton-domain {
  margin-bottom: var(--space-3);
}

.skeleton-exam {
  margin-left: 20px;
  margin-top: var(--space-2);
  margin-bottom: var(--space-2);
}

.skeleton-topic {
  margin-left: 40px;
  margin-top: var(--space-1);
}

/* ============================================
   SKELETON LINES - Animated Placeholders
   ============================================ */

.skeleton-line {
  height: 20px;
  background: var(--bg-surface);
  border-radius: var(--radius-sm);
  animation: skeleton-shimmer 1.5s ease-in-out infinite;
  margin-bottom: var(--space-1);
}

/* Domain lines: 60% width */
.skeleton-domain-line {
  width: 60%;
}

/* Exam lines: 70% width */
.skeleton-exam-line {
  width: 70%;
}

/* Topic lines: 80% width */
.skeleton-topic-line {
  width: 80%;
}

/* ============================================
   SHIMMER ANIMATION
   ============================================ */

@keyframes skeleton-shimmer {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1.0;
  }
  100% {
    opacity: 0.6;
  }
}

/* ============================================
   ACCESSIBILITY - Reduced Motion
   ============================================ */

@media (prefers-reduced-motion: reduce) {
  .skeleton-line {
    animation: none;
    opacity: 0.7;
  }
}

/* ============================================
   RESPONSIVE
   ============================================ */

@media (max-width: 768px) {
  .hierarchy-skeleton {
    padding: var(--space-2) var(--space-1);
  }

  .skeleton-exam {
    margin-left: 12px;
  }

  .skeleton-topic {
    margin-left: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hierarchy/HierarchySkeleton.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,sCAAsC;AACxC;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ============================================\n   HIERARCHY SKELETON - Loading Placeholder\n   ============================================ */\n\n.hierarchy-skeleton {\n  padding: var(--space-3) var(--space-2);\n}\n\n/* ============================================\n   TREE STRUCTURE - Indentation Levels\n   ============================================ */\n\n.skeleton-domain {\n  margin-bottom: var(--space-3);\n}\n\n.skeleton-exam {\n  margin-left: 20px;\n  margin-top: var(--space-2);\n  margin-bottom: var(--space-2);\n}\n\n.skeleton-topic {\n  margin-left: 40px;\n  margin-top: var(--space-1);\n}\n\n/* ============================================\n   SKELETON LINES - Animated Placeholders\n   ============================================ */\n\n.skeleton-line {\n  height: 20px;\n  background: var(--bg-surface);\n  border-radius: var(--radius-sm);\n  animation: skeleton-shimmer 1.5s ease-in-out infinite;\n  margin-bottom: var(--space-1);\n}\n\n/* Domain lines: 60% width */\n.skeleton-domain-line {\n  width: 60%;\n}\n\n/* Exam lines: 70% width */\n.skeleton-exam-line {\n  width: 70%;\n}\n\n/* Topic lines: 80% width */\n.skeleton-topic-line {\n  width: 80%;\n}\n\n/* ============================================\n   SHIMMER ANIMATION\n   ============================================ */\n\n@keyframes skeleton-shimmer {\n  0% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1.0;\n  }\n  100% {\n    opacity: 0.6;\n  }\n}\n\n/* ============================================\n   ACCESSIBILITY - Reduced Motion\n   ============================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .skeleton-line {\n    animation: none;\n    opacity: 0.7;\n  }\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n\n@media (max-width: 768px) {\n  .hierarchy-skeleton {\n    padding: var(--space-2) var(--space-1);\n  }\n\n  .skeleton-exam {\n    margin-left: 12px;\n  }\n\n  .skeleton-topic {\n    margin-left: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
